import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { resetFilters, resetParams } from '@components/Explore/helpers';
import { setExploreType } from '@components/Explore/useSearchPageStore';
import { useUserNotificationStatus } from '@components/Notifications/useUserNotificationStatus';
import {
  MobileNavLinkAvatarV2,
  MobileNavLinkV2,
} from '@components/main-components/mobile-nav/NavLinkV2';
import { MOBILE_NAV_ID } from '@components/main-components/mobile-nav/constants';
import { useAuth } from '@context/auth/base';
import { useNavActions } from '@hooks/useNavActions';
import { webappUriPath } from '@utils/url';
import { MOBILE_NAV_LINKS } from './sections';

export const MobileNavV2 = () => {
  const { authUser } = useAuth();
  const { hasUnreadNotifications } = useUserNotificationStatus();
  const {
    onNotificationsClick,
    onProfileClick,
    isHomepageActive,
    isFeedActive,
    isExploreActive,
    isNotificationActive,
    isProfileActive,
    isSignInActive,
  } = useNavActions();

  return (
    <div
      className={clsx(
        'fixed bottom-0 z-mobileNav flex h-[calc(68px+env(safe-area-inset-bottom))] w-screen items-center justify-center border-t',
        'border-base100 bg-white px-3 pb-[calc(12px+env(safe-area-inset-bottom))] pt-3 md:hidden',
      )}
      style={{
        WebkitTapHighlightColor: 'transparent',
      }}
      id={MOBILE_NAV_ID}
    >
      <div className="flex w-full justify-between gap-1">
        <MobileNavLinkV2
          label={MOBILE_NAV_LINKS.HOME.label}
          icon={
            <FontAwesomeIcon
              icon={
                isHomepageActive
                  ? MOBILE_NAV_LINKS.HOME.activeIcon
                  : MOBILE_NAV_LINKS.HOME.inactiveIcon
              }
            />
          }
          pathname={MOBILE_NAV_LINKS.HOME.pathname}
          isActive={isHomepageActive}
        />
        <MobileNavLinkV2
          label={MOBILE_NAV_LINKS.FEED.label}
          icon={
            <FontAwesomeIcon
              icon={
                isFeedActive ? MOBILE_NAV_LINKS.FEED.activeIcon : MOBILE_NAV_LINKS.FEED.inactiveIcon
              }
            />
          }
          pathname={MOBILE_NAV_LINKS.FEED.pathname}
          isActive={isFeedActive}
        />
        <MobileNavLinkV2
          label={MOBILE_NAV_LINKS.EXPLORE.label}
          icon={
            <FontAwesomeIcon
              icon={
                isExploreActive
                  ? MOBILE_NAV_LINKS.EXPLORE.activeIcon
                  : MOBILE_NAV_LINKS.EXPLORE.inactiveIcon
              }
            />
          }
          pathname={MOBILE_NAV_LINKS.EXPLORE.pathname}
          isActive={isExploreActive}
          onClick={() => {
            resetFilters();
            resetParams();
            setExploreType({ type: null });
          }}
        />
        <MobileNavLinkV2
          label={MOBILE_NAV_LINKS.NOTIFICATIONS.label}
          icon={
            <FontAwesomeIcon
              icon={
                isNotificationActive
                  ? MOBILE_NAV_LINKS.NOTIFICATIONS.activeIcon
                  : MOBILE_NAV_LINKS.NOTIFICATIONS.inactiveIcon
              }
            />
          }
          pathname={MOBILE_NAV_LINKS.NOTIFICATIONS.pathname}
          isActive={isNotificationActive}
          notificationIndicator={hasUnreadNotifications}
          onClick={onNotificationsClick}
        />
        {authUser ? (
          <MobileNavLinkAvatarV2
            label={MOBILE_NAV_LINKS.PROFILE.label}
            isActive={isProfileActive}
            publicAddress={authUser.publicAddress}
            username={authUser.username}
            webappUri={webappUriPath(authUser.webappUri)}
            avatarUrl={authUser.avatar?.url}
            onClick={onProfileClick}
          />
        ) : (
          <MobileNavLinkV2
            label={MOBILE_NAV_LINKS.SIGNIN.label}
            icon={
              <FontAwesomeIcon
                icon={
                  isSignInActive
                    ? MOBILE_NAV_LINKS.SIGNIN.activeIcon
                    : MOBILE_NAV_LINKS.SIGNIN.inactiveIcon
                }
              />
            }
            pathname={MOBILE_NAV_LINKS.SIGNIN.pathname}
            isActive={isSignInActive}
          />
        )}
      </div>
    </div>
  );
};
